import { LazyModule } from 'owa-bundling';
import createLazyPlugin, { LazyPlugin } from 'owa-editor-lazy-plugin/lib/utils/createLazyPlugin';
import TableEditPlugin from './plugin/TableEditPlugin';
import tableEditImportTrigger from './utils/tableEditImportTrigger';

const lazyModule = new LazyModule(() => import(/* webpackChunkName: "HtmlEditor" */ './lazyIndex'));

export type LazyTableEditPlugin = LazyPlugin<TableEditPlugin>;
export const LazyTableEditPluginClass = createLazyPlugin(
    lazyModule,
    m => m.TableEditPlugin,
    'TableEdit',
    tableEditImportTrigger
);

export { default as TableEditViewState } from './store/schema/TableEditViewState';
export { default as createTableEditViewState } from './utils/createTableEditViewState';
